import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import CardBartChart from "../../../../../cards/SimpleBarchart";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { yearOptions } from "../config";
import { configFincoyContribution } from "./config";
import { service } from "./service";

class FincoyContributionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      isPercentageChart: false,
    };
  }

  componentDidMount = () => {
    let currentDate = new Date();
    this.setState(
      (prevValue) => ({
        ...prevValue,
        year: yearOptions.find(
          (item) => item.value === currentDate.getFullYear(),
        ),
        tableConfig: configFincoyContribution(),
      }),
      () => {
        if (this.props.search) {
          this.fetchData();
        }
      },
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (!R.equals(this.props.search, prevProps.search)) {
      this.fetchData();
    }
  }

  constructTableData = (data) => {
    return data.map((item) => {
      const { dataLastThreeYear = {}, ...rest } = item;
      return {
        ...rest,
        ...dataLastThreeYear[0],
      };
    });
  };

  constructTable = () => {
    return this.state.dataTable.map((item) => {
      if (!R.isNil(item)) {
        return (
          <SimpleDataTable
            key={`table-${item.namaCabang}`}
            title={item?.namaCabang}
            data={this.constructTableData(item?.dataLeasingLastThreeYear)}
            columns={this.state.tableConfig}
          />
        );
      }
    });
  };

  constructChart = () => {
    console.log();
    if (this.state.isPercentageChart) {
      return this.state.dataTable.map((item, index) => {
        if (!R.isNil(item)) {
          const key = service.parseDataKeyFincoyL3Y(
            item.dataLeasingLastThreeYear,
          );
          const dt = service.parseDataChartFincoyL3Y(
            item.dataLeasingLastThreeYear,
            true,
            this.state.year?.value
          );
          return (
            <CardBartChart
              key={`chart-${index}`}
              data={dt}
              dataKey={key}
              yAxisType="percentage"
            />
          );
        }
        return <></>;
      });
    }
    return this.state.dataTable.map((item, index) => {
      if (!R.isNil(item)) {
        const key = service.parseDataKeyFincoyL3Y(
          item.dataLeasingLastThreeYear,
        );
        const dt = service.parseDataChartFincoyL3Y(
          item.dataLeasingLastThreeYear,
          false,
          this.state.year?.value
        );
        return <CardBartChart key={`chart-${index}`} data={dt} dataKey={key} />;
      }
      return <></>;
    });
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        tableConfig: configFincoyContribution(prev.year?.value),
      }),
      () => this.fetchData(),
    );
  };

  fetchData = async () => {
    this.props.handleTriggerLoading();
    let dataKodeCabang = this.props.search;
    if (this.props.isAllSelected) {
      dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
    }

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO")
          .getLaporanKontribusiFincoyPerCabangLastThreeYear,
      setError: this.props.setError,
      menuName: "Dashboard Sales - Laporan Fincoy Contribution",
      args: {
        kodeCabang: dataKodeCabang,
        year: this.state.year?.value,
        employeeIdTeamLeader: this.props.idLeader,
      },
    });
    this.props.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
      }));
    }
  };

  handleChangeSearchValue(name, value) {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  }

  handleChartPercentageToggle = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      isPercentageChart: !prevValue.isPercentageChart,
    }));
  };

  render() {
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "20px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <FlexView
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                width: "100%",
              }}
            >
              {this.constructTable()}
            </div>
          </FlexView>
        )}
        {/* {this.state.chartVisible && this.constructChart()} */}
        {this.state.chartVisible && (
          <FlexView
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                width: "100%",
              }}
            >
              {this.constructChart()}
            </div>
          </FlexView>
        )}
        <FlexView
          style={{ gap: "20px", marginTop: "20px", justifyContent: "end" }}
        >
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
          {this.state.chartVisible && (
            <SimpleButton onClick={this.handleChartPercentageToggle}>
              Percentage / Value
            </SimpleButton>
          )}
        </FlexView>
      </React.Fragment>
    );
  }
}

export default FincoyContributionReport;
